/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

function NewSubscriptionModal (_,
                               $q,
                               uiGridConstants,
                               ContentResourceFactory,
                               NetworkResourceFactory,
                               PartnerResourceFactory,
                               SubscriptionsResourceFactory
) {

	const self = this;

	self.loadingIndicator = {
		backdrop: true,
		show: false,
		title: 'Working',
		message: 'Please wait...'
	};

	self.selectedPartner = null;
	self.availablePartners = [];

    //====================//
    // Required MAPs grid //
    //====================//

    var dropdownSortByName = (a, b) => {
        return _.toLower(a).localeCompare(_.toLower(b));
    };

    var artworkGridColumns = [
        {
            field: 'artworkAcceptProfile.name',
            name: 'Required Artwork MAPs',
            sortable: true,
            enableSorting: true,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 1
            },
            sortingAlgorithm: dropdownSortByName,
            enableColumnMenu: false,
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        }
    ];

    self.artworkGridOptions = {
        columnDefs: artworkGridColumns,
        enableColumnResizing: false,
        enablePaginationControls: false,
        rowHeight: 26,
        minRowsToShow: 4,
        enableVerticalScrollbar: 2,
        onRegisterApi: function (gridApi) {
            self.artworkGridApi = gridApi;
        }
    };

	//===================//
    // Template Response //
    //===================//

	const filterPartnersList = () => {
		_.forEach(self.subscriptions, (subscription) => {
			if (subscription.partner && subscription.partner.id) {
				_.forEach(self.availablePartners, (partner, index) => {
					if (partner && partner.id) {
						if (partner.id === subscription.partner.id) {
							self.availablePartners.splice(index, 1);
						}
					}
				});
			}
		});
	};

	self.onPartnerSelected = () => {
        delete self.selectedArtwork;
        self.artworkSeasonVolume = false;

        self.requiredArtworks.splice(0);
        _.forEach(self.selectedPartner.artwork, (requiredProfile) => {
            let packageCategoryTypeId = _.get(requiredProfile, 'packageCategoryType.id');
            if (!packageCategoryTypeId || packageCategoryTypeId === self.resolve.packageCategoryTypeId) {
                self.requiredArtworks.push({
                    artwork: null,
                    artworkAcceptProfile: requiredProfile.acceptProfile,
                    artworkSeasonVolume: false
                });
            }
        });
    };

    // Update artwork in the subscription's format
    self.onArtworkSelected = () => {
        _.forEach(self.requiredArtworks, (rowEntity) => {
            rowEntity.artwork = self.selectedArtwork;
        });
    };

    self.onSVCheckboxClicked = () => {
        _.forEach(self.requiredArtworks, (rowEntity) => {
            rowEntity.artworkSeasonVolume = self.artworkSeasonVolume;
        });
    };

	self.isOkEnabled = () => {
	    return (self.selectedPartner && (!_.size(self.selectedPartner.artwork) || self.selectedArtwork));
    };

	self.onOk = () => {
		self.close({
            $value: {
		        partner: self.selectedPartner,
                artwork: self.requiredArtworks
		    }
		});
	};

	self.cancel = () => {
		self.dismiss({$value: 'cancel'});
	};

	//=================//
    // Lifecycle Hooks //
    //=================//

    const getArtworks = () => {
        return $q.all({
            content: ContentResourceFactory.get({id: self.resolve.contentId, view: 'EXTENDED'}).$promise,
            network: NetworkResourceFactory.get({id: self.resolve.networkId, view: 'EXTENDED'}).$promise
        }).then((artworkData) => {
            let content = artworkData.content;
            self.availableArtworks = _.concat(content.artwork, artworkData.network.artwork);
            self.showMovieSpecialCheckbox = (!content || content.type !== 'Movie/Special');
            return self.availableArtworks;
        });
    };

	self.$onInit = () => {
		self.loadingIndicator.show = true;
		self.showMovieSpecialCheckbox = true;
        self.availableArtworks = [];
        self.selectedArtwork = null;
        self.artworkSeasonVolume = false;
        // Use 'requiredArtworks' as an alias for "all the grid's rows"
        self.requiredArtworks = [];
        self.artworkGridOptions.data = self.requiredArtworks;

        getArtworks();
        $q.all({
            partners: PartnerResourceFactory.query({
                fetchLimit: -1,
                includeChildren: false
            }).$promise,
            subscriptions: SubscriptionsResourceFactory.getSubscriptionsByContentCategory(
                {
                    contentId: self.resolve.contentId,
                    categoryId: self.resolve.packageCategoryId,
                    includeDisabled: true
                }).$promise
        }).then((data) => {
			self.availablePartners = data.partners;
            self.subscriptions = data.subscriptions;
			filterPartnersList();

		});
	};
}

angular.module('prism-ui.content').component('newSubscriptionModal', {
	templateUrl: 'meta/content/editor/components/modals/newSubscriptionModal/new-subscription-modal-template.html',
	controller: NewSubscriptionModal,
	bindings: {
		dismiss: '&',
		close: '&',
		resolve: '<'
	}
});
